import {type FC, type RefObject, useEffect} from 'react';
import CenterWait from '../../../assets/broadcast/center-wait.jpg';
import useStreamingStore from '../../../store/useStreamingStore.ts';
import type {JitsiTrackState} from '../types/lib-jitsi-meet';
import type {ILayOut} from '../../../utils/StreamingUtil.ts';

interface LocalCellProps {
    localElemRef: RefObject<HTMLVideoElement | null>;
    localTrack: RefObject<JitsiTrackState>;
    localTrackVersion: number;
    gridInfo: ILayOut;
}

const LocalCell: FC<LocalCellProps> = ({localElemRef, localTrack, localTrackVersion, gridInfo}) => {
    const {state, gridLayout, isMicMuted} = useStreamingStore();

    useEffect(() => {
        const currentVideoTrack = localTrack.current?.videoTrack;
        const currentAudioTrack = localTrack.current?.audioTrack;
        const videoElement = localElemRef.current;
        const audioElement = document.getElementById('local-cell-audio');
        return () => {
            if (videoElement && currentVideoTrack) currentVideoTrack.detach(videoElement);
            if (audioElement && currentAudioTrack) currentAudioTrack.detach(audioElement);
        };
    }, [localTrackVersion]);

    useEffect(() => {
        const id = setTimeout(() => {
            const currentVideoTrack = localTrack.current?.videoTrack;
            const currentAudioTrack = localTrack.current?.audioTrack;
            const videoElement = localElemRef.current;
            const audioElement = document.getElementById('local-cell-audio');
            if (currentVideoTrack && videoElement) currentVideoTrack.attach(videoElement);
            if (currentAudioTrack && audioElement) currentAudioTrack.attach(audioElement);
        }, 3000);
        return () => clearTimeout(id);
    }, [localTrackVersion]);

    return (
        <div
            id="local-cell"
            style={{
                gridColumn: `${gridInfo.localCol} / span ${gridInfo.localColSpan}`,
                gridRow: `${gridInfo.localRow} / span ${gridInfo.localRowSpan}`,
                width: '100%',
                backgroundImage: `url(${CenterWait})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                padding: '0',
                position: 'relative',
                overflow: 'hidden',
                zIndex: '3',
            }}
        >
            <video
                id="local-cell-video"
                autoPlay={true}
                style={{
                    display: 'block',
                    backgroundImage: `url(${CenterWait})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    objectFit: 'cover',
                    padding: '0',
                    width: '100%',
                    aspectRatio: '16/9',
                }}
                crossOrigin="anonymous"
                ref={localElemRef}
            />
            <audio id="local-cell-audio" className="jitsiTrack" autoPlay={true} />
            {!isMicMuted && (
                <div
                    className="participant-name"
                    style={{
                        maxWidth: '95%',
                        position: 'absolute',
                        top: '3.5%',
                        right: '2%',
                        fontSize: '1rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        padding: '0.5rem',
                        borderRadius: '50%',
                    }}
                />
            )}
            {gridLayout.sub && (
                <div
                    className="participant-name"
                    style={{
                        maxWidth: '95%',
                        position: 'absolute',
                        bottom: '0',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontSize: '1rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        padding: '0.1rem',
                    }}
                >
                    {state.username}
                </div>
            )}
        </div>
    );
};

export default LocalCell;
